<template>
  <div class="customers">
    <div class="customers-main" data-aos="fade-up" data-aos-duration="1000">
      <div class="customers-title">
        <h3>客户案例</h3>
        <p>成功服务1200+企业客户</p>
      </div>
      <div class="customers-wrap" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="200">
        <!-- <div class="customers-wrap-item" v-for="(item,index) in logos">
          <img :src="item.src" :style="item.style" />
        </div>-->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      logos: [
        {
          src: require("../../../assets/home/customers/logo1.png"),
          style: "width:128px;height:38px"
        },
        {
          src: require("../../../assets/home/customers/logo2.png"),
          style: "width:124px;height:42px"
        },
        {
          src: require("../../../assets/home/customers/logo3.png"),
          style: "width:90px;height:40px"
        },
        {
          src: require("../../../assets/home/customers/logo4.png"),
          style: "width:126px;height:24px"
        },
        {
          src: require("../../../assets/home/customers/logo5.png"),
          style: "width:113px;height:50px"
        },
        {
          src: require("../../../assets/home/customers/logo6.png"),
          style: "width:135px;height:27px"
        },
        {
          src: require("../../../assets/home/customers/logo7.png"),
          style: "width:104px;height:36px"
        },
        {
          src: require("../../../assets/home/customers/logo8.png"),
          style: "width:120px;height:35px"
        },
        {
          src: require("../../../assets/home/customers/logo9.png"),
          style: "width:92px;height:42px"
        },
        {
          src: require("../../../assets/home/customers/logo10.png"),
          style: "width:69px;height:62px"
        },
        {
          src: require("../../../assets/home/customers/logo11.png"),
          style: "width:129px;height:40px"
        },
        {
          src: require("../../../assets/home/customers/logo12.png"),
          style: "width:124px;height:46px"
        },
        {
          src: require("../../../assets/home/customers/logo13.png"),
          style: "width:128px;height:40px"
        },
        {
          src: require("../../../assets/home/customers/logo14.png"),
          style: "width:83px;"
        },
        {
          src: require("../../../assets/home/customers/logo15.png"),
          style: "width:69px;height:37px"
        },
        {
          src: require("../../../assets/home/customers/logo16.png"),
          style: "width:110px;height:45px"
        },
        {
          src: require("../../../assets/home/customers/logo17.png"),
          style: "width:109px;height:44px"
        },
        {
          src: require("../../../assets/home/customers/logo18.png"),
          style: "width:136px;height:50px"
        },
        {
          src: require("../../../assets/home/customers/logo19.png"),
          style: "width:145px;height:33px"
        },
        {
          src: require("../../../assets/home/customers/logo20.png"),
          style: "width:119px;height:40px"
        }
      ]
    };
  }
};
</script>
<style lang="less" scoped>
.customers {
  width: 100%;
  min-width: 1200px;
  padding-bottom: 20px;
  background-color: #fff;
}
.customers-main {
  height: 100%;
  width: 1200px;
  margin: 0 auto;
  margin-bottom: 80px;
  background-color: #fff;

  .customers-title {
    width: 1200px;
    margin: 0 auto;
    margin-bottom: 80px;
    text-align: center;
    padding-top: 80px;
    h3 {
      font-size: 28px;
      color: #3b3435;
    }
    p {
      margin-top: 20px;
      font-size: 16px;
      font-weight: 300;
      color: #aba1a2;
    }
  }
  .customers-wrap {
    width: 1040px;
    height: 300px;
    margin: 0 auto;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    background-image: url("../../../assets/home/customers/logoall.jpg");
    // background-color: #ccc;
    display: -webkit-flex; /* Safari */
    display: flex;
    flex-wrap: wrap;
    .customers-wrap-item {
      width: 208px;
      height: 75px;
      transition: all 0.3s;
      border: 1px solid rgba(60, 70, 77, 0.1);
      border-left: none;
      border-bottom: none;
      background-color: #fff;
      display: -webkit-flex; /* Safari */
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .customers-wrap-item:nth-child(-n + 5) {
      border-top: none;
    }
    .customers-wrap-item:nth-child(5n) {
      border-right: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/home/components/customers.vue